/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <article class="card-product product-tile switch-image-hover" :data-sku="product.sku">
    <div class="card-product__topbar"></div>
    <div class="card-product__media">
      <a href="javascript:;" @click.prevent="openQuickBuy">
        <image-gallery
        :hasVideo="hasVideo ? hasVideo.video_content.video_url : ''"
        :imgPath="product.image.url"
        :alt="product.image.label"
        :defaultLoading="defaultLoading"
        size="MD"
        :changeAble="false"
        />
      </a>
    </div>
    <div class="card-product__info">
      <div class="card-product__info__intro">
        <a href="javascript:;" @click.prevent="openQuickBuy" class="cl-black card-product__info__intro__link">
          <p class="card-product__info__intro__link__name">{{product.name}}</p>
        </a>
          <div class="card-product__info__intro__price">
          <product-price :product="product"></product-price>
        </div>
        <div class="card-product__info__attributes" v-if="showOutOfStock">
          <span class="f-semibold cl-black text-uppercase t-small">{{ $t('OUT_OF_STOCK') }}</span>
        </div>
        <color-selector-sibiling
        class="card-product__info__intro__color"
        :product="product"
        :showTitle="false"
        @siblingChange="siblingChange"
        />
      </div>
    </div>
    <absolute-loader :showLoader="showLoader" minHeight="auto"></absolute-loader>
  </article>
</template>

<script>
import ImageGallery from 'theme/components/Product/Image'
import ColorSelectorSibiling from 'theme/components/Product/Variants/ColorSelectorSibiling'
import ProductPrice from 'theme/components/Listing/ProductPrice'
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'
import { localizedByName } from '@/filters/routers'

export default {
  props: {
    product: {
      type: Object,
      required: true
    },
    listIndex: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      showLoader: false,
      defaultLoading: require('theme/assets/image/listing-tile.png')
    }
  },
  computed: {
    productLink () {
      if (this.product) {
        let path = '/'
        // width category path
        if (this.$store.state.category.current && this.$store.state.category.current.url_path) {
          path += this.$store.state.category.current.url_path + '/'
        }
        return localizedByName('factoryPage', this.$store, this.$router) + path + this.product.url_key + this.product.url_suffix
      }
      return ''
    },
    hasVideo () {
      // if product has video show it
      // otherwise show image
      let video = this.product.media_gallery.find((g) => g.video_content)
      return video
    },
    showOutOfStock () {
      if (this.product.qty <= 0) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.product && this.product.presetFilter) {
      this.filterActive = this.product.presetFilter
    }
  },
  methods: {
    openQuickBuy ($event) {
      // const _this = this
      this.$store.commit('quickBuy/setToggle', true)
      this.$store.commit('quickBuy/setCurrentProductUrlKey', this.productLink)
    },
    siblingChange ($event) {
      this.showLoader = true
      this.$store.dispatch('listing/updateListingByIndex', { listIndex: this.listIndex, newProduct: $event })
        .finally(() => {
          this.showLoader = false
        })
    },
    getFilterCompose (newValues) {
      return { type: this.parentAttribute, value: newValues }
    }
  },
  components: {
    ImageGallery,
    ColorSelectorSibiling,
    AbsoluteLoader,
    ProductPrice
  }
}
</script>
